<template>
  <div>
    <avs-backButton />
    <TemplateEditor :templateId="templateId" />
  </div>
</template>

<script>
export default {
  name: "TemplateEditorView",
  components: {
    TemplateEditor: () => import("@/components/ri3/documents/TemplateEditor.vue")
  },
  data() {
    return {
      templateId: Number.parseInt(this.$route.params.id) || -1,
      loading: true
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
